import React from "react";
import { User } from "../../types";
import { useApp } from "../../context/AppContext";
import Button from "../ui/Button";
import Badge from "../ui/Badge";

interface Props {
  user: User;
  onLogout: () => void;
  collapsed: boolean;
}

const TopBar: React.FC<Props> = ({ user, onLogout, collapsed }) => {
  const { orgs } = useApp();
  const org = orgs.find(o => o.id === user.orgId);

  return (
    <header
      className={`fixed top-0 right-0 z-30 h-16 flex items-center justify-between px-6 transition-all duration-300 ${collapsed ? "left-16" : "left-64"}`}
      style={{
        background: "rgba(255,255,255,0.75)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        borderBottom: "1px solid rgba(255,255,255,0.35)",
        boxShadow: "0 2px 16px rgba(99,102,241,0.06)",
      }}
    >
      {/* Left */}
      <div className="flex items-center gap-2.5">
        <span className="text-base font-bold text-gray-700 capitalize">
          {user.role.replace(/_/g, " ")}
        </span>
        {org && <Badge text={org.name} />}
      </div>

      {/* Right */}
      <div className="flex items-center gap-4">
        {/* Notification bell */}
        <button className="relative w-9 h-9 rounded-xl hover:bg-gray-100 flex items-center justify-center text-gray-500 transition-colors">
          🔔
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
        </button>

        {/* User info */}
        <div className="hidden sm:flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-white font-bold text-sm shadow-sm">
            {user.name[0]}
          </div>
          <div className="text-right hidden md:block">
            <p className="text-sm font-bold text-gray-800 leading-tight">{user.name}</p>
            <p className="text-xs text-gray-400">{user.email}</p>
          </div>
        </div>

        <Button variant="secondary" size="sm" onClick={onLogout}>
          Sign Out
        </Button>
      </div>
    </header>
  );
};

export default TopBar;
